import React from 'react';
import PropTypes from 'prop-types';

import { dig } from 'spiceutils';

import { Select } from 'spicecomponents';

const SingleYear = (props) => {
  const onChange = (value) => {
    if (value !== 'None') {
      props.onChange([value]);
    } else {
      props.onChange(null);
    }
  };

  return (
    <Select options={getOptions(props.controlList)} value={getValue(props.cdf)} onChange={onChange} />
  );
};

const getOptions = (controlList) => (
  [{ text: 'Default', value: 'None' }].concat(
    controlList.Options.map((year) => ({
      value: year,
    }))
  )
);

const getValue = (cdf) => (
  dig(cdf, ['YearsToShow', 0]) || 'Value'
);

SingleYear.propTypes = {
  controlList: PropTypes.object,
  cdf: PropTypes.object,
  onChange: PropTypes.func,
};

export default SingleYear;



// WEBPACK FOOTER //
// ./app/components/FormControls/YearsToShow/SingleYear.js